import React, { FC } from 'react';
import './avatar.scss';

type AvatarSize = 'small' | 'medium' | 'large';

interface AvatarProps {
	src?: string;
	alt?: string;
	name?: string;
	size?: AvatarSize;
}

const Avatar: FC<AvatarProps> = ({ src, alt, name = '', size = 'medium' }) => {
	const getInitials = (name: string): string => {
		if (!name) return 'A';
		const parts = name.split(' ');

		return parts.length > 1
			? `${parts[0][0]}${parts[1][0]}`.toUpperCase()
			: parts[0][0].toUpperCase();
	};

	return (
		<div className={`avatar avatar--${size}`}>
			{src ? (
				<img className="avatar__image" src={src} alt={alt || 'Avatar'} />
			) : (
				<span className="avatar__initials">{getInitials(name)}</span>
			)}
		</div>
	);
};

export default Avatar;
